export default "__VITE_ASSET__BRWOBW$3__"